// --------------------------------------------------------------------------
// #55 – Activity filter module
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var children = require('../../utilities/children');

module.exports = function (options) {
    var context = options.context[0];
    var $context = $(context);
    var filterRows = context.querySelectorAll('.activity-filter__filter-row');
    var filterRowButton = context.querySelector('.activity-filter__filter-row--button');
    var filterOptions = context.querySelectorAll('[data-binding="filter-options"]');
    var showMore = '<button class="show-more-filters" data-binding="show-more-filters" type="button">' + '<span class="text">Show more</span>' + '<span class="plus"></span>' + '</button>';
    var moreFilters = '<button class="show-more-categories" data-binding="show-more-categories" type="button">' + '<span class="text">More filters</span>' + '<span class="plus"></span>' + '</button>';

    if (window.matchMedia) {
        var mq = window.matchMedia('screen and (max-width: 940px)');
    }

    function init() {
        function handleMobile() {
            if (mq.matches) {
                $context.addClass('closed');
            } else {
                $context.removeClass('closed').removeClass('open');
            }
        }

        if (mq.addListener) {
            mq.addListener(handleMobile);
            handleMobile();
        }

        $context.on('click', function (e) {
            if (this === e.originalEvent.target) {
                $context.toggleClass('open').toggleClass('closed');
            }
        });

        $context.on('click', '[data-binding="show-more-filters"]', function (e) {
            e.preventDefault();
            var buttonText = $(this).find('.text');
            var plus = $(this).find('.plus');
            var hiddenFilters = $(this).parents('[data-binding="filter-options"]').find('.activity-filter__option:gt(3)');

            hiddenFilters.toggle();
            plus.toggleClass('open');
            buttonText.text(function () {
                var text = $(this).text() === 'Show more' ? 'Show less' : 'Show more';
                return text;
            });
        });

        $context.on('click', '[data-binding="show-more-categories"]', function (e) {
            e.preventDefault();
            var buttonText = $(this).find('.text');
            var plus = $(this).find('.plus');
            var filtersAreHidden = $(this).text() === 'More filters';
            var $filterRows = $(filterRows);

            if (filtersAreHidden) {
                $filterRows.show();
            } else {
                $filterRows.filter(':gt(2)').hide();
            }

            plus.toggleClass('open');
            buttonText.text(function () {
                var text = filtersAreHidden === true ? 'Less filters' : 'More filters';
                return text;
            });
        });

        for (var i = 0; i < filterOptions.length; i++) {
            var childNodes = children(filterOptions[i]).length;
            if (childNodes > 4) {
                $(filterOptions[i]).append(showMore);
                $(filterOptions[i]).find('.activity-filter__option:gt(3)').hide();
            }
        }

        if (filterRows.length > 3) {
            var $filterRows = $(filterRows);
            $filterRows.filter(':gt(2)').hide();
            $(filterRowButton).prepend(moreFilters);
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activity-filter.js
// module id = 96
// module chunks = 0